import ResourceList from "@/components/ResourceList";
import { Bell } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Reminders() {
  return (
    <ResourceList
      title="Reminders"
      subtitle="Gentle nudges"
      resource="reminders"
      icon={Bell}
      testidPrefix="reminders"
      emptyText="No reminders yet"
      itemTitle={(r) => r.title}
      itemSubtitle={(r) => {
        const parts = [];
        if (r.due_at) parts.push(new Date(r.due_at).toLocaleString());
        if (r.recurrence) parts.push(r.recurrence);
        return parts.join(" · ");
      }}
      itemBadge={(r) => (
        <div className="mt-2 flex items-center gap-2">
          {r.done && <span className="text-xs bg-[#3E7B5C]/15 text-[#3E7B5C] rounded-full px-3 py-1">Done</span>}
          {r.channel && <span className="text-xs bg-[#EBE8E0] text-[#576A62] rounded-full px-3 py-1">{r.channel}</span>}
        </div>
      )}
      extraActions={(r, reload) => (
        <button
          data-testid={`reminders-toggle-${r.id}`}
          onClick={async () => {
            await api.patch(`/reminders/${r.id}`, { done: !r.done });
            toast.success(r.done ? "Marked as pending" : "Marked as done");
            reload();
          }}
          className="mt-3 w-full rounded-full text-sm px-4 py-1.5 border border-[#EBE8E0] hover:bg-[#EBE8E0]/60"
        >
          {r.done ? "Mark as pending" : "Mark as done"}
        </button>
      )}
      fields={[
        { key: "title", label: "Title", required: true, placeholder: "Take blood pressure" },
        { key: "due_at", label: "Due", type: "datetime-local" },
        { key: "recurrence", label: "Recurrence", options: [
          { value: "", label: "None" },
          { value: "daily", label: "Daily" },
          { value: "weekly", label: "Weekly" },
          { value: "monthly", label: "Monthly" },
        ] },
        { key: "channel", label: "Delivery", options: [
          { value: "in_app", label: "In-app" },
          { value: "email", label: "Email" },
          { value: "sms", label: "SMS (text)" },
        ] },
        { key: "notes", label: "Notes", textarea: true },
      ]}
    />
  );
}
